import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { DesktopFooter } from '@vc-workspace/desktop-footer';
import { MobileFooter } from '@vc-workspace/mobile-footer';
import { useEffect } from 'react';
import { AmplitudeEventNames, sendAmplitudeData } from '@vc-workspace/utils-amplitude';
import { HomePageSectionTypes, PageTypes, VibecityAccessibility } from '@vc-workspace/utils-constants';
import { getCurationPageSections } from '@vc-workspace/data-adapter';
import ItemCollectionSection from '../../components/item-collection-section/item-collection-section';
import CollectionGroup from '../../components/collection-group/collection-group';
import HomepageShopGroup from '../../components/homepage-shop-group/homepage-shop-group';
import HomepageBannerWidget from '../../components/homepage-banner-widget/homepage-banner-widget';
import { UtilsInfiniteScroll } from '@vc-workspace/utils-infinite-scroll';
import { getCookie } from 'cookies-next';
import GlobalContextWrapper from '../../components/global-context-wrapper/global-context-wrapper';
import { useInfiniteQuery } from '@tanstack/react-query';
import CategoryCollectionGroup from '../../components/category-collection-group/category-collection-group';
import { Typography } from '@vc-workspace/utils-typography';
import MobileBottomNavbar, { NavItemsLabel } from '../../components/mobile-bottom-navbar/mobile-bottom-navbar';
import BasicSEO from '../../components/seo/BasicSEO';
import { PageLoader } from '@vc-workspace/utils-loader';
var PAGINATION_INCREMENT = 1;
export var __N_SSP = true;
export function CurationPage(props) {
  var _useInfiniteQuery = useInfiniteQuery(['homePage', getCookie("session_".concat(props.context.params[1]))], function (_ref) {
    var pageParam = _ref.pageParam;
    return getCurationPageSections(props.context.params[1], getCookie("session_".concat(props.context.params[1])) ? getCookie("session_".concat(props.context.params[1])) : null, PAGINATION_INCREMENT, pageParam, props.context.isMobileView ? VibecityAccessibility.Mobile : VibecityAccessibility.Desktop);
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading;

  useEffect(function () {
    if (data) {
      sendAmplitudeData(AmplitudeEventNames.PAGE_VIEWED, {
        page_type: PageTypes.CATEGORY_LANDING_PAGE,
        page_identifier: data.pages[0].pageTitle
      });
    }
  }, [data]);

  var onNextClick = function onNextClick(nextPage) {
    fetchNextPage({
      pageParam: nextPage
    });
  };

  return /*#__PURE__*/_jsxs(GlobalContextWrapper, {
    context: props.context,
    pageName: data === null || data === void 0 ? void 0 : data.pages[0].pageTitle,
    disableNavActions: props.context.isMobileView,
    showCustomSearch: props.context.isMobileView,
    attributionData: {
      allowed: true,
      query: props.context.query,
      page_type: PageTypes.CATEGORY_LANDING_PAGE,
      page_id: ''
    },
    children: [/*#__PURE__*/_jsx("link", {
      rel: "stylesheet",
      type: "text/css",
      href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
    }), /*#__PURE__*/_jsx("link", {
      rel: "stylesheet",
      type: "text/css",
      href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
    }), /*#__PURE__*/_jsx(BasicSEO, {
      title: data === null || data === void 0 ? void 0 : data.pages[0].pageTitle
    }), data && data.pages.length ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [data.pages.map(function (page, pageIndex) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: page.widgets.map(function (widget, index) {
            switch (widget.type) {
              case HomePageSectionTypes.SIA_COLLECTION:
                return /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx(ItemCollectionSection, {
                    data: widget,
                    context: props.context,
                    rowIndex: index * PAGINATION_INCREMENT
                  })
                });

              case HomePageSectionTypes.CATEGORY_SIA_COLLECTION_GROUP:
                return /*#__PURE__*/_jsx(CategoryCollectionGroup, {
                  data: widget,
                  context: props.context,
                  hideTitle: true
                });

              case HomePageSectionTypes.SIA_COLLECTION_GROUP:
                return /*#__PURE__*/_jsx(CollectionGroup, {
                  data: widget,
                  context: props.context
                });

              case HomePageSectionTypes.SHOP_GROUP:
                return /*#__PURE__*/_jsx(HomepageShopGroup, {
                  data: widget,
                  context: props.context
                });

              case HomePageSectionTypes.BANNER_CAROUSEL:
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(HomepageBannerWidget, {
                    data: widget,
                    context: props.context,
                    positionIndex: pageIndex
                  }), pageIndex === 0 && !props.context.isMobileView ? /*#__PURE__*/_jsx(Typography, {
                    type: "Heading3",
                    color: "nero",
                    className: "text-center pt-12",
                    bold: true,
                    children: data.pages[0].pageTitle
                  }) : null]
                });
            }
          })
        });
      }), data.pageParams.length === 1 || data.pageParams[data.pageParams.length - 1] < data.pages[0].totalWidgetCount ? /*#__PURE__*/_jsx("div", {
        className: "text-align",
        children: /*#__PURE__*/_jsx(UtilsInfiniteScroll, {
          currPage: data.pages.length - 1,
          callback: onNextClick,
          gridCount: props.context.isMobileView ? 2 : 7
        })
      }) : null]
    }) : null, isLoading && !data ? /*#__PURE__*/_jsx(PageLoader, {}) : null, props.context.isMobileView ? /*#__PURE__*/_jsx(MobileFooter, {}) : /*#__PURE__*/_jsx(DesktopFooter, {}), props.context.isMobileView ? /*#__PURE__*/_jsx(MobileBottomNavbar, {
      selectedTab: NavItemsLabel.HOME
    }) : null]
  });
}
export default CurationPage;